export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';